/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular.module("uCountitUiApp").directive("dateSearchContainer", () => ({
  restrict: "E",
  templateUrl: "components/range-search-container/date-search-container.html",

  scope: {
    searchOptions: "=",
    loadCallback: "=",
  },

  controller(
    $scope,
    $stateParams,
    $location,
    DateTimeSrv,
    rangePickerCacheSrv,
    ApiSrv,
    contentSrv
  ) {
    const DEFAULT_PICKER = {
      minView: "date",
      maxView: false,
      view: "date", // year, month, date, hours, minutes
      sampling: "day",
      maxDate: moment(),
    }
    $scope.cachedTime = {}
    $scope.pickerOptions = {}

    const getCachedSearchTime = function () {
      return rangePickerCacheSrv.getCachedTimeByTimezone("UTC", "search")
    }

    const getReferenceDate = function (date, sampling) {
      if (!date) {
        return date
      }

      if (sampling === "month") {
        return moment(date).startOf("month")
      }

      return moment(date).endOf(sampling)
    }

    const parseQueryDate = function () {
      const query = $location.search()
      const to = moment.utc(query.to, moment.ISO_8601, true)
      const from = moment.utc(query.from, moment.ISO_8601, true)
      const { sampling } = $scope.pickerOptions

      if (to.isValid()) {
        return getReferenceDate(to, sampling)
      }

      if (from.isValid()) {
        return getReferenceDate(from, sampling)
      }

      return null
    }

    const clearQueryDate = function () {
      $location.search("from", null)
      $location.search("to", null)
    }

    $scope.gotoDate = function (type) {
      let diffDays
      const { dt } = $scope.cachedTime
      const { sampling } = $scope.pickerOptions
      if (["hour", "day"].indexOf(sampling) < 0) {
        diffDays = 0
      } else {
        diffDays = moment(dt.endDate).diff(dt.startDate, sampling)
      }
      const options = {
        orgType: $stateParams.orgType,
        orgId: $stateParams.id,
        content: $scope.searchOptions.content,
      }

      const getDateFunc = type === "first" ? contentSrv.getFirstDate : contentSrv.getLastDate

      return getDateFunc(options)
        .then(function (date) {
          const normalizedDate = moment(date).utc(true)
          const theDateTime = moment(normalizedDate).endOf(sampling)
          const referenceDate = getReferenceDate(normalizedDate, sampling)
          const newdt = {
            startDate: moment(referenceDate).subtract(diffDays, sampling).startOf(sampling),
            endDate: theDateTime,
          }
          $scope.searchOptions.referenceDay = referenceDate
          rangePickerCacheSrv.putCacheDates(newdt, "search")
          clearQueryDate()
          if ($scope.loadCallback) {
            return $scope.loadCallback()
          }
        })
        .catch((err) => console.error((err != null ? err.message : undefined) || err))
    }

    $scope.changeDate = function (date) {
      let diffDays
      const { dt } = $scope.cachedTime
      const { sampling } = $scope.pickerOptions
      if (["hour", "day"].indexOf(sampling) < 0) {
        diffDays = 0
      } else {
        diffDays = moment(dt.endDate).diff(dt.startDate, sampling)
      }

      const newdt = {
        startDate: moment(date).subtract(diffDays, sampling).startOf(sampling),
        endDate: moment(date).endOf(sampling),
      }
      const referenceDate = getReferenceDate(date, sampling)

      rangePickerCacheSrv.putCacheDates(newdt, "search")
      $scope.cachedTime.dt = newdt
      $scope.searchOptions.referenceDay = referenceDate
      clearQueryDate()
      if ($scope.loadCallback) {
        return $scope.loadCallback()
      }
    }

    const setDatetimeConfiguration = function (timezone) {
      const today = DateTimeSrv.getLocalTimeByTimezone(timezone).utc(true)
      const configuration = DateTimeSrv.getDateTimeConfiguration(today)
      $scope.pickerOptions.maxDate = configuration.maxDate

      const queryDate = parseQueryDate()
      if (queryDate) {
        let normalizedDate = queryDate
        if ($scope.pickerOptions.maxDate.isBefore(normalizedDate)) {
          normalizedDate = getReferenceDate(
            $scope.pickerOptions.maxDate,
            $scope.pickerOptions.sampling
          )
        }
        $scope.searchOptions.referenceDay = normalizedDate
        $scope.cachedTime = {
          dt: {
            startDate: moment(normalizedDate).startOf($scope.pickerOptions.sampling),
            endDate: moment(normalizedDate).endOf($scope.pickerOptions.sampling),
          },
        }
        return
      }

      const res = getCachedSearchTime()
      if (res) {
        if ($scope.pickerOptions.maxDate.isBefore(res.dt.endDate)) {
          res.dt.endDate = $scope.pickerOptions.maxDate
        }
        $scope.searchOptions.referenceDay = getReferenceDate(
          res.dt.endDate,
          $scope.pickerOptions.sampling
        )
        $scope.cachedTime = { dt: res.dt }
        return
      } else {
        $scope.searchOptions.referenceDay = getReferenceDate(
          configuration.dt.endDate,
          $scope.pickerOptions.sampling
        )
        $scope.cachedTime = {
          dt: configuration.dt,
        }
        return
      }
    }

    const initDateSearch = function () {
      $scope.pickerOptions = {}
      for (var key in DEFAULT_PICKER) {
        var value = DEFAULT_PICKER[key]
        $scope.pickerOptions[key] =
          $scope.searchOptions[key] != null ? $scope.searchOptions[key] : value
      }
      setDatetimeConfiguration($scope.timezone, $scope.searchOptions)
      if ($scope.loadCallback) {
        return $scope.loadCallback(true)
      }
    }

    $scope.$watch("searchOptions.content", function (newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        return ($scope.isGotoDate = contentSrv.isSupportGotoDate(newVal, $stateParams.orgType))
      }
    })

    $scope.$on("init-date-search", function (e, timezone) {
      $scope.timezone = timezone
      $scope.isGotoDate = contentSrv.isSupportGotoDate(
        $scope.searchOptions.content,
        $stateParams.orgType
      )
      return initDateSearch()
    })

    return
  },
}))
